import { estadoPagoLabel } from '../../utils/cobranzas';

export const CATEGORIAS_VENTA = ['Honorarios', 'Asesoría mensual', 'Proyecto único', 'Otro'];

export function formatFecha(fecha) {
  if (!fecha) return '—';
  const s = String(fecha).slice(0, 10);
  const [y, m, d] = s.split('-').map(Number);
  if (!y || !m || !d) return String(fecha);
  return new Date(y, m - 1, d).toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function pagoBadgeClass(f, modoOscuro) {
  const label = estadoPagoLabel(f);
  if (label === 'Pagada') return modoOscuro ? 'bg-green-700 text-white' : 'bg-green-100 text-green-800';
  if (label === 'Parcial') return modoOscuro ? 'bg-amber-800 text-white' : 'bg-amber-100 text-amber-800';
  return modoOscuro ? 'bg-red-800 text-white' : 'bg-red-100 text-red-800';
}

export function isQuickSale(factura) {
  return String(factura?.documentType || '').trim().toLowerCase() === 'venta rápida'
    || factura?.metadata?.entryMode === 'quick';
}

export function saleTypeBadgeClass(factura, modoOscuro) {
  if (isQuickSale(factura)) {
    return modoOscuro
      ? 'bg-blue-900/50 text-blue-200 border-blue-700'
      : 'bg-blue-50 text-blue-800 border-blue-200';
  }
  return modoOscuro
    ? 'bg-gray-800 text-gray-300 border-gray-700'
    : 'bg-gray-50 text-gray-700 border-gray-200';
}

export function amountInArs(f) {
  const m = String(f?.moneda || 'ARS').toUpperCase();
  if (m === 'ARS') return Number(f.total) || 0;
  if (f.montoArs != null) return Number(f.montoArs) || 0;
  if (f.tipoCambio && Number(f.tipoCambio) > 0) return (Number(f.total) || 0) * Number(f.tipoCambio);
  return 0;
}
